import React, { useState } from "react";
import { NavBar } from "./NavBar";
import Logo from "../assets/simbol-Pillar.webp";
import ContactLogo from "../assets/logo-Pillar.webp";
import { Modal } from "antd";
import QuoteImg from "../assets/QuoteImg.webp";
import { Input } from "antd";

export function GetAQuote({ onOpenModal }) {
  const { TextArea } = Input;

  return (
    <>
      <section className="aboutUs">
        <div className="aboutUsContainer">
          <img src={QuoteImg} className="aboutUsImg quoteImg" />
          <div className="aboutUsText quoteText">
            <img
              src={Logo}
              alt="Pillar Hydraulics Logo"
              className="logoSmall"
            />
            <h6>request project</h6>
            <h3>Please Inquire</h3>

            <p className="bodyText">
              for different size accumulators with multiple pressure ratings
            </p>
            <button className="yellowBtn" onClick={onOpenModal}>
              Get a Quote
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
